// extracted by mini-css-extract-plugin
export default {"aboutSection":"TeamContext_aboutSection__adtrY","line1":"TeamContext_line1__Dnsqk"};